import { createComponent } from '@mtfe/sweet';
import { eventBus, dom, lazyLoadImg } from '@mtfe/sweet-utils';

import style from './style.less';
import tpl from './dom.html';
import componentUtils from '../../utils/index';

let isLoading = false;

const { startImgListener } = lazyLoadImg;
const { getOnClickEventName } = componentUtils;

const PoiListComp = (props = {}) => {
    const {
        listInfo,
        isOpenAutoLoading = true,
        renderPoiFunc,
        fetchDataList,
        scrollLoading,
        http,
    } = props;

    const { recallBizId, bottomTipID, poiContainerID } = listInfo;
    const onClickEventName = getOnClickEventName(recallBizId);
    eventBus.clearEvent(onClickEventName);
    eventBus.$on(onClickEventName, async () => {
        if (isLoading) {
            return;
        }
        try {
            const { poiList, pageNo } = listInfo;
            const listDom = dom.$id(poiContainerID);
            const renderOption = { marginClass: 'mt16' };
            if (pageNo === 1) {
                const poiInfo = await fetchDataList({ listInfo });
                poiList.push(...poiInfo);
            }
            listDom.innerHTML = poiList
                .map((poiInfo, index) => renderPoiFunc(poiInfo, index, recallBizId, renderOption))
                .join('');

            const { scrollLoadingInit, setEnding } = scrollLoading({
                dataList: poiList,
                reportObserve: http.gMonitorApi,
                renderItem: (poiInfo, itemIndex) => {
                    const res = renderPoiFunc(poiInfo, itemIndex, recallBizId, renderOption);
                    return res;
                },
                fetchDataList: async () => {
                    const res = await fetchDataList({ listInfo });
                    return res;
                },
                listContainerID: poiContainerID,
                bottomTipID,
            });
            if (poiList.length === 0) {
                setEnding();
            } else {
                if (isOpenAutoLoading) {
                    scrollLoadingInit();
                } else {
                    scrollLoadingInit();
                    setEnding();
                }
            }
            startImgListener();
        } catch (error) {
            console.error(error);
        }
    });

    const events = {};
    const data = {
        poiContainerID,
        bottomTipID,
    };
    const component = createComponent(tpl, { data, style }, events);
    return component;
};
export default PoiListComp;
